export default "__VITE_ASSET__DjPIzRSk__"